import React from 'react';
import CardItem from './CardItem';
import './Cards.css';

function Cards() {
  return (
    <div className='cards'>
        <h1>The Best Coding School for your Child!</h1>
        <div className="cards__container">
            <div className="cards__wrapper">
                <ul className="cards__items">
                    <CardItem 
                    src="images/raise-hand.jpg"
                    text="With a 1:4 to 1:1 student-teacher ratio, every child has the opportunity to ask questions and receive the support they need to excel."
                    label='Individualized Attention'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/bilingual.jpg"
                    text="We offer lessons in both English and Mandarin, allowing students to learn Mandarin while enjoying hands-on activities."
                    label='Bilingual Learning'
                    path='/programme'
                    />
                </ul>
                <ul className="cards__items">
                    <CardItem 
                    src="images/lego-power-function.jpg"
                    text="Dive into engineering concepts and mechanical knowledge using LEGO Technic, building a strong foundation in STEM."
                    label='Engineering and Mechanics'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/lego-wedo.jpg"
                    text="Build and program robots with LEGO WeDo, combining robotics and coding for an interactive learning experience."
                    label='Robotics and Coding'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/scratch.jpg"
                    text="Learn to code and create games from scratch using SCRATCH MIT, fostering creativity and coding skills through fun projects."
                    label='Game Development'
                    path='/programme'
                    />
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Cards
